// extracted by mini-css-extract-plugin
export default {"srtAddOrderContainer":"Booking-components-AddOrderDialog-___stylesAddOrder__srtAddOrderContainer___2-bY5"};